import React from 'react';
import { Card as AntCard } from 'antd';
import Skeleton from '../Skeleton/Skeleton';

/**
 * @typedef {'sm'|'md'|'lg'} CardPadding
 */

const PADDING_MAP = {
  sm: 16,
  md: 24,
  lg: 32,
};

/**
 * Shared Card component — standardizes padding and hover behaviour.
 * If loading={true}, renders Skeleton inside instead of children.
 *
 * @param {object}          props
 * @param {React.ReactNode} [props.title]
 * @param {React.ReactNode} [props.extra]
 * @param {React.ReactNode} props.children
 * @param {boolean}         [props.hoverable=false]
 * @param {boolean}         [props.loading]
 * @param {CardPadding}     [props.padding='md']
 * @param {string}          [props.className]
 */
const Card = ({
  title,
  extra,
  children,
  hoverable = false,
  loading,
  padding = 'md',
  className,
  styles: stylesProp,
  ...rest
}) => (
  <AntCard
    title={title}
    extra={extra}
    hoverable={hoverable}
    className={className}
    styles={{
      ...stylesProp,
      body: {
        padding: PADDING_MAP[padding],
        ...(stylesProp?.body || {}),
      },
    }}
    {...rest}
  >
    {loading ? <Skeleton rows={3} /> : children}
  </AntCard>
);

export default Card;
